<template>
	<div style="background-color: #f6f6f6;">
		<div class="content" ref="content">
			<div v-if="chatList.length == 0" class="zw">暂无记录</div>
			<div v-if="chatList.length > 0">
				<el-row v-for="(item,index) in chatList" v-bind:key="index">
					<div v-if="!(item.senderName == name && item.senderRole == position) ">
						<el-col :span="15">
							<el-row>
								<el-col :span="3" style="padding-top: 10px;text-align: center;">
									<el-avatar :size="50" :src="avater"></el-avatar>
								</el-col>
								<el-col :span="20">
									<el-row>
										<div style="float: left;padding: 0 10px 0 0;">
											{{item.senderName}}
										</div>
										<div style="float: left;margin-top: 0;padding: 0 5px;" class="position">
											{{item.senderRole}}
										</div>
										<div style="float: right;color: #cccccc;">
											{{item.updateTime}}
										</div>
									</el-row>
									<div class="chat" style="float: left;">
										{{item.communicationContent}}
									</div>
								</el-col>
							</el-row>
						</el-col>
					</div>
					<div v-else-if="(item.senderName == name && item.senderRole == position)">
						<el-col :span="9">
							<div style="width: 1px;height: 1px;"></div>
						</el-col>
						<el-col :span="15">
							<el-row>
								<el-col :span="21">
									<el-row>
										<div style="float: right;padding: 0 0 0 10px;">
											{{item.senderName}}
										</div>
										<div style="float: right;margin-top: 0;padding: 0 5px;" class="position">
											{{item.senderRole}}
										</div>
										<div style="float: left;color: #cccccc;">
											{{item.updateTime}}
										</div>
									</el-row>
									<div class="chat" style="float: right;">
										{{item.communicationContent}}
									</div>
								</el-col>
								<el-col :span="3" style="padding-top: 10px;text-align: center;">
									<el-avatar :size="50" :src="avater2"></el-avatar>
								</el-col>
							</el-row>
						</el-col>
					</div>
				</el-row>
			</div>
			
		</div>
		<div style="padding: 30px;background-color: #ffffff;margin-top: 30px;">
			<el-input class="textarea" rows="5" type="textarea" placeholder="请输入内容" v-model="form.content"
				maxlength="1000" show-word-limit>
			</el-input>
			<el-row style="padding-top: 20px;">
				<el-col :span="12">
					<el-row>
						<div style="float: left;">
							<el-avatar :size="50" :src="avater2"></el-avatar>
						</div>
						<div style="float: left;padding: 15px 10px;">
							{{name}}
						</div>
						<div style="float: left;">
							<div class="position">
								{{position}}
							</div>
						</div>
					</el-row>
				</el-col>
				<el-col :span="12" style="text-align: right;">
					<el-button type="primary" :loading="isLoading" @click="save">发 布</el-button>
				</el-col>
			</el-row>
		</div>

	</div>
</template>

<script>
	import api from '@/service/api.js';
	import head1 from "@/assets/images/head_1.png"
	import head2 from "@/assets/images/head_2.png"
	export default {
		props: {
			patientId: {
				required: true
			},
			recordId: {
				required: true
			},
			customerId: {
				required: true
			},
			mainDoctorId:{
				required: true
			},
			diseaseManagerId:{
				required: false
			}
			
		},
		data() {
			return {
				id:0,
				name: "",
				avater: head1,
				avater2: head2,
				position: "",
				list:{
					pageSize:10,
					pageNumber:1,
					recordId:0
				},
				form: {
					content: ""
				},
				chatList: [],
				isLoading: false,
				load:true,
			}
		},
		created() {
			if (+this.$route.query.t2 == 5) {
				this.init();
			}
		},
		mounted() {
			this.$refs.content.addEventListener('scroll', this.handleScroll);
		},
		methods: {
			init() {
				let user = JSON.parse(localStorage.getItem("user"));
				this.name = user.data.name;
				this.id = user.data.user.id;
				this.position = user.data.user.roleName;
				this.getInfoList();
				setTimeout(() => {
					this.$refs["content"].scrollTop = this.$refs["content"].scrollHeight;
				},100);
			},
			async save() {
				if(this.form.content.trim().length > 0){
					let data = {
						"communicationContent":this.form.content,
						"communicationType":1,
						"followupId":null,
						"patientId":this.patientId,
						"receiverId":this.diseaseManagerId,
						"receiverType":null,
						"recordId":this.recordId,
						"remark":null,
						"sendDatasources":2,
						"senderId":this.id,
						"senderType":1
					};
					let res = await api.addCommunicationDialogue(data);
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.form.content = "";
					this.list.pageNumber = 1;
					this.getInfoList();
					this.$nextTick(()=>{
						this.$refs["content"].scrollTop = this.$refs["content"].scrollHeight;
					})
				}
			},
			async getInfoList(){
				if (this.recordId != "") {
					this.isLoading = true;
					this.load = false;
					this.list.recordId = this.recordId;
					let res = await api.communicationDialogueList(this.list);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					
					if(this.list.pageNumber == 1){
						this.chatList = res.data.reverse();
					}else{
						let list = this.chatList.reverse();
						for(let i=0;i<res.data.length;i++){
							list.push(res.data[i]);
						}
						this.chatList = list.reverse();
					}
					
					/* let list = [];
					for(let i=res.data.length-1;i>=0;i--){
						list.push(res.data[i]);
					}
					if(this.list.pageNumber == 1){
						this.chatList = list;
					}else{
						let l = this.chatList;
						
						for(let i=res.data.length-1;i>=0;i--){
							list.push(res.data[i]);
						}
						
					} */
					this.load = true;
					//console.log(this.chatList);
				}
			},
			handleScroll() {
				if(this.load && this.$refs["content"].scrollTop < 1){
					this.list.pageNumber++;
					this.getInfoList();
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	@import '@/assets/style/var';

	.textarea {
		font-size: 20px;
		resize: none;
		padding-top: 15px;
		outline: none;
		border-color: #E5E5E5;
	}

	.position {
		border: 1px solid #409EFF;
		border-radius: 5px;
		font-size: 12px;
		background-color: #ECF5FF;
		color: #409EFF;
		margin-top: 15px;
		text-align: center;
		height: 18px;
	}

	.chat {
		margin: 10px 0;
		max-width: 100%;
		min-width: 0;
		padding: 12px 16px;
		border-radius: 4px;
		background: #FFFFFF;
		box-shadow: 1px 1px 2px 1px #E5E5E5;
		white-space: pre-line;
		word-wrap: break-word;
		word-break: normal;
	}

	.content {
		padding: 50px;
		border-top: 1px solid #eee;
		height: 300px;
		background-color: #ffffff;
		overflow-x: auto;
	}
	
	.zw{
		text-align: center;
		color: #808080;
	}
</style>
